export default "__VITE_ASSET__CfHA6JpW__"